export default __webpack_public_path__ + "static/media/system_maintenance.c44c8ed8.webp";